exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-details-btn {\r\n\tfont-family: Roboto;\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-size: 14px;\r\n    line-height: 150%;\r\n    letter-spacing: 0.02em;\r\n    color: #2F79EB;\r\n}\r\n\r\n.error i, .error span {\r\n\tfont-family: Roboto;\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-size: 14px;\r\n    line-height: 150%;\r\n    letter-spacing: 0.02em;\r\n    color: #4E4E4E;\r\n}\r\n\r\na.error-details-btn ~ ul.error-dates { display: none;}\r\na.error-details-btn.show-date ~ ul.error-dates { display: block;}\r\n\r\nul.error-dates { margin-top: 10px; list-style: none;}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/zoomView/errors/errors.component.css
// module id = ../../../../../src/app/reports/myReports/zoomView/errors/errors.component.css
// module chunks = main